import {feLogger, feSendBeaconLogger} from './index';

enum RepType {
    Click = 'click',
    Show = 'show',
}

export enum ParamsType {
    Doc = '1',
    PPT = '2',
}

const saveVersionClick = '80001.14.1';
const customVersionTabClick = '80001.14.2';
const copyVersionLinkClick = '80001.14.3';
const selectVersionClick = '80001.14.4';
const demoVersionClick = '80001.14.5';
const backBtnClick = '80001.14.6';

const report = (reportId: string, type: ParamsType = ParamsType.Doc) => {
    feLogger({
        rep_id: reportId,
        rep_type: RepType.Click,
        rep_params: {
            type,
        },
    });
};

export const reportSaveVersionClick = (type?: ParamsType) => {
    report(saveVersionClick, type);
};

export const reportCustomVersionTabClick = (type?: ParamsType) => {
    report(customVersionTabClick, type);
};

export const reportCopyVersionLinkClick = (type?: ParamsType) => {
    report(copyVersionLinkClick, type);
};

export const reportSelectVersionClick = (type?: ParamsType) => {
    report(selectVersionClick, type);
};

export const reportDemoVersionClick = (type?: ParamsType) => {
    report(demoVersionClick, type);
};

export const reportBackBtnClick = (type?: ParamsType) => {
    feSendBeaconLogger(backBtnClick, {type}, RepType.Click);
};
